import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { HttpService } from "services/http.service";
import { BenefitProviderModel } from "services/models/corporate/benefit/benefitProvider.model";
import { ServiceBase } from "services/servicebase";

@Injectable()
export class BenefitProviderService extends ServiceBase<BenefitProviderModel> {
	constructor(http: HttpService) {
		super("benefitprovider", http, environment.apiUrl);
	}

	createEntity(input: any): BenefitProviderModel {
		return BenefitProviderModel.create(input);
	}

	openDetailsFile(id: string) {
		this.http.get(`${this.endpoint}/${id}/details-file`).subscribe(
			({ body }) => {
				window.open(body, "_blank");
			},
			(error) => {
				console.log("error service", error);
			}
		);
	}
}
